module.exports = __webpack_public_path__ + "static/media/liveroom-vip-respected.27c33f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/liveroom-vip-respected.png
// module id = 2021
// module chunks = 6